var map = {
	"./quiz-pic-0.jpeg": 1058,
	"./quiz-pic-1.jpeg": 1059,
	"./quiz-pic-2.jpeg": 1060,
	"./quiz-pic-3.jpeg": 1061,
	"./quiz-pic-4.jpeg": 1062,
	"./quiz-pic-5.jpeg": 1063,
	"./quiz-pic-6.jpeg": 1064,
	"./quiz-pic-7.jpeg": 1065,
	"./quiz-pic-8.jpeg": 1066,
	"./quiz-pic-9.jpeg": 1067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1057;